// extracted by mini-css-extract-plugin
export var banner = "_j8-0";
export var closeButton = "_j8-2";
export var greenCheckmark = "_j8-3";
export var hereLink = "_j8-4";
export var titleIcon = "_j8-1";